import { useMemo } from "react";
import ko from "date-fns/locale/ko";
import enUS from "date-fns/locale/en-US";
import it from "date-fns/locale/it";
import { useTranslation } from "react-i18next";

/** 현재 앱 언어(i18n)에 맞는 date-fns Locale 객체를 반환한다. */
export default function useDateFnsLocale() {
  const { i18n } = useTranslation();
  const lang = i18n.language || "en";
  return useMemo(() => {
    if (lang === "ko") return ko;
    if (lang === "it") return it;
    return enUS;
  }, [lang]);
}
